import { arrayToMap } from "../util";

const list = [
  { key: 0, name: "指定なし", value: null },
  { key: 1, name: "1"       , value: 1 },
  { key: 2, name: "2"       , value: 2 },
  { key: 3, name: "3"       , value: 3 },
  { key: 4, name: "4"       , value: 4 },
  { key: 5, name: "5"       , value: 5 },
  { key: 6, name: "6"       , value: 6 },
  { key: 7, name: "7"       , value: 7 },
  { key: 8, name: "8"       , value: 8 },
];

for (const item of list) {
  item.text = item.name;
}

export const data = {
  list: list,
  byValue: arrayToMap(list, "value"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/extentNew.js